//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import { AlertBox } from '@components/primitives/alert/AlertBox';
import { getIsMediaLibraryStreamsEnabled } from '@media-library/redux/getMediaLibraryPage';

export const StreamsDeprecationBanner = () => {
  const isEnabled = useSelector(getIsMediaLibraryStreamsEnabled);

  // TODO: PD-319070 - Remove feature check once MediaLibraryStreams is released
  if (!isEnabled) {
    return null;
  }

  return (
    <BannerWrapper>
      <AlertBox.Root type='warning'>
        <AlertBox.Icon>
          <Icon name='lightbulb' />
        </AlertBox.Icon>
        <AlertBox.Content>
          To streamline your workflow, we're consolidating all media management
          features into the Content Library page. Starting January 31, 2027,
          this page will no longer be available.
        </AlertBox.Content>
      </AlertBox.Root>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div(
  ({ theme }) => `
    padding: ${theme.spacings[2]} ${theme.spacings[3]};
  `,
);
